import { render, staticRenderFns } from "./edros-details.vue?vue&type=template&id=feb820da&scoped=true&"
import script from "./edros-details.vue?vue&type=script&lang=js&"
export * from "./edros-details.vue?vue&type=script&lang=js&"
import style0 from "./edros-details.vue?vue&type=style&index=0&id=feb820da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb820da",
  null
  
)

component.options.__file = "edros-details.vue"
export default component.exports